import React from 'react';
import {
  DocumentPickerTab,
  DOCUMENT_PICKER_TABS,
} from '~/src/types/clioDocumentPicker';

interface DocumentPickerHeaderProps {
  title: string;
  onClose: () => void;
  activeTab: DocumentPickerTab;
  onTabChange: (tab: DocumentPickerTab) => void;
  selectedCount?: number;
  maxSelectionLimit?: number;
}

export const DocumentPickerHeader: React.FC<DocumentPickerHeaderProps> = ({
  title,
  onClose,
  activeTab,
  onTabChange,
  selectedCount = 0,
  maxSelectionLimit,
}) => {
  return (
    <div className="bg-white border-b border-gray-200">
      {/* Title and Close Button */}
      <div className="flex items-center justify-between px-6 pt-6 pb-4">
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        <button
          onClick={onClose}
          className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          aria-label="Close document picker"
        >
          <svg
            className="w-5 h-5 text-gray-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Description */}
      <div className="px-6 pb-4">
        <p className="text-sm text-gray-600">
          {maxSelectionLimit && selectedCount >= maxSelectionLimit
            ? `You have reached the document selection limit of ${maxSelectionLimit}`
            : 'Only showing DOCX. matter documents and document templates with a file size up to 5MB.'}
        </p>
      </div>

      {/* Tabs */}
      <div className="px-6">
        <div className="border-b border-gray-200">
          <nav className="-mb-px flex space-x-8">
            <button
              onClick={() => onTabChange(DOCUMENT_PICKER_TABS.MATTER_DOCUMENTS)}
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === DOCUMENT_PICKER_TABS.MATTER_DOCUMENTS
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Matter documents
            </button>
            <button
              onClick={() =>
                onTabChange(DOCUMENT_PICKER_TABS.DOCUMENT_TEMPLATES)
              }
              className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === DOCUMENT_PICKER_TABS.DOCUMENT_TEMPLATES
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Document templates
            </button>
          </nav>
        </div>
      </div>
    </div>
  );
};
